import * as React from 'react'
import tw from 'tailwind-styled-components'
import {Button} from '@components/common/base/buttons'
import {cn} from '@containers/html-utils'
import {globals} from '@extensions/globals-base'

const TwContainer = tw.div<{
  $errorBg?: boolean
  $show?: boolean
  $theme: 'dark' | 'light'
}>`
  absolute
  bottom-0

  rounded-12
  bg-background-solid

  p-8
  flex
  items-center
  gap-8

  transition-all
  w-full
  shrink-0

  ${p => (p.$errorBg ? 'bg-status-error' : '')}
  ${p => (p.$show ? 'opacity-100' : 'opacity-0 invisible')}
  ${p => (p.$theme === 'light' ? 'shadow-lg' : '')}
`

const TwError = tw.div<{$errorBg?: boolean}>`
  text-sm-semibold

  pl-8
  cursor-default
  ${p => (p.$errorBg ? 'text-invert' : 'text-status-error')}
`

interface Props {
  show?: boolean
  primaryText: string
  primaryClick: () => void
  secondaryText: string
  secondaryClick: () => void
  error?: boolean
  errorText?: string
  errorBg?: boolean
  className?: string
}

export const ActionsPanel = (props: Props) => {
  const {primaryText, primaryClick, secondaryText, secondaryClick} = props
  const {className} = props
  const errorBg = props.error && props.errorBg
  const theme = globals.theme
  const isLight = theme === 'light'

  return (
    <TwContainer
      $errorBg={errorBg}
      $show={props.show}
      $theme={theme}
      className={className}
    >
      {props.error && <TwError $errorBg={errorBg}>{props.errorText}</TwError>}

      <Button
        color="secondary"
        className={cn(
          'ml-auto',
          isLight ? 'bg-background-primary' : 'bg-background-solid'
        )}
        onClick={secondaryClick}
        rounded={'8'}
      >
        {secondaryText}
      </Button>

      <Button color="primary" onClick={primaryClick} rounded={'8'}>
        {primaryText}
      </Button>
    </TwContainer>
  )
}
